import { useState } from "react";
import DarkModeToggle from "./DarkModeToggle";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-white/80 dark:bg-gray-900/80 backdrop-blur-md shadow z-50">
      <div className="max-w-6xl mx-auto px-6 h-[64px] flex items-center justify-between relative">

        
        <div className="flex items-center gap-4">
          <div className="block lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 dark:text-gray-300 text-2xl focus:outline-none"
            >
              {isOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
          <div className="hidden lg:block">
            <DarkModeToggle />
          </div>
        </div>

        
        <ul className="hidden lg:flex absolute left-1/2 -translate-x-1/2 gap-8 text-sm font-medium text-gray-700 dark:text-gray-300">
          <li><a href="#about" className="hover:text-blue-500 transition">About</a></li>
          <li><a href="#projects" className="hover:text-blue-500 transition">Projects</a></li>
          <li><a href="#certifications" className="hover:text-blue-500 transition">Certifications</a></li>
          <li><a href="#contact" className="hover:text-blue-500 transition">Contact</a></li>
        </ul>

        
        <div className="ml-auto lg:hidden">
          <DarkModeToggle />
        </div>
      </div>

    
      {isOpen && (
        <div className="lg:hidden px-6 pb-4">
          <ul className="flex flex-col gap-4 mt-2 text-sm font-medium text-gray-700 dark:text-gray-300">
            <li><a href="#about" onClick={() => setIsOpen(false)} className="hover:text-blue-500 transition">About</a></li>
            <li><a href="#projects" onClick={() => setIsOpen(false)} className="hover:text-blue-500 transition">Projects</a></li>
            <li><a href="#certifications" onClick={() => setIsOpen(false)} className="hover:text-blue-500 transition">Certifications</a></li>
            <li><a href="#contact" onClick={() => setIsOpen(false)} className="hover:text-blue-500 transition">Contact</a></li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
